if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"storeWebFront","remotes":[{"alias":"storeWebAssets","name":"storeWebAssets","entry":"https://store-web-assets.prod.instant-system.com/remoteEntry.js","shareScope":"default"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return /^5[02]4$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}